var Util = UIkit.util;
window.theme = window.theme || {};
var $site = {
    breakpoint: 992,
    _isIE: /MSIE|Trident/.test(window.navigator.userAgent), // ie10 ie11
    _isSmallScreen: false,

    init: function () {
        this._isSmallScreen = ((Util.width(window) < this.breakpoint) ? true : false);
        this.navigation();
        this.footerDropDowns();
        this.buttonAnims()
    },


    buttonAnims: function (container) {

        container = container || "body";
        var selector = ".uk-button-primary, .uk-button-secondary, .uk-button-outline";
        var $b = Util.$$(selector, Util.$(container));

        if (!$b) return;

        Util.each($b, function (item) {
            Util.append(item, "<span></span>");
        });

        Util.on(selector, "mouseenter", function (e) {
            var parentOffset = Util.offset(e.target),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            Util.$("span:last-child", e.target).style.setProperty("top", relY + "px");
            Util.$("span:last-child", e.target).style.setProperty("left", relX + "px");
        });
    },


    footerDropDowns: function () {
        setTimeout(function () {
            Util.each(Util.$$(".widget-accordion .widget-title"), function (item) {
                var t = Util.data(item, "list");
                if (t) {
                    UIkit.toggle(item, {
                        target: t,
                        mode: "media,click",
                        media: "640",
                        animation: "uk-animation-slide-top-small"
                    });
                    Util.on(t, "beforehide", function (e) {
                        if (Util.width(window) > 767) {
                            e.preventDefault();
                        }
                    })
                }
            });
        }, 1000);
    },


    /**
     * Mobile Navigation
     */
    navigation: function () {

        var el = document.querySelector("#navbar-wrapper-mobile");

        if (typeof el === "undefined" || el === null) {
            return;
        }

        Util.on(window, "load resize", theme.Utility.debounce(function () {
            var mobileMenu = $("#navbar-wrapper-mobile");
            var h = theme.Utility.getUsableHeight();
            var hh = h() - 95; // Header height
            mobileMenu.height(hh);
        }, 50))

        var socialbox = Util.$(".follow-us-list"),
            currencySelector = Util.$(".currency-selector"),
            navbars = [];

        if (typeof socialbox == "undefined" || socialbox == null) {
            var clone = '';
            navbars = []
        } else {

            // Add Social panel to the mobile menu
            var clone = socialbox.cloneNode(true);
            clone.insertBefore(document.createElement('li'), Util.$("li", clone));
            Util.$("li", clone).innerHTML = "<small>FOLLOW US ON</small>"
            Util.removeClass(clone, "uk-navbar-item navbar-nav-secondary uk-visible@xl")
            Util.addClass(clone, "for-mobile social-box");

            var mobileCurrencySelector = currencySelector.cloneNode(true);
            var mobCurrencyContainer = document.createElement('div');

            // Remove form ID
            Util.attr(Util.$('form', mobCurrencyContainer), "id", 'currency_form_mobile');
            Util.addClass(mobCurrencyContainer, "currency-selector-container");

            mobCurrencyContainer.appendChild(mobileCurrencySelector);

            //Add Currency selector
            navbars = [{
                "position": "bottom",
                "content": [clone, mobCurrencyContainer]
            }];
        }

        if (Util.$(".header-top") != null) {
            Util.addClass(Util.$("body"), "has-notification-bar");
        }

        var menu = new Mmenu(el, {
            onClick: {
                close: true
            },
            scrollBugFix: false,
            extensions: ["position-top", "fx-panels-slide-100"],
            "navbars": navbars
        }, {});

        var menuAPI = menu.API;

        menuAPI.bind("close:start", function () {
            Util.removeClass(Util.$(".uk-navbar-toggler"), "uk-active");
        });

        Util.each(Util.$$(".mm-navbar__title"), function (item) {
            Util.html(item, "Back");
        });

        jQuery(".mm-panel:not(#mm-1) .mm-listview > li:first-child a").attr("href", "");
        jQuery(".mm-panel:not(#mm-1) .mm-listview > li:first-child a").removeAttr("href");

        // Mobile menu toggle button

        Util.on(Util.$$(".uk-navbar-toggle"), "click", function (e) {
            e.preventDefault();

            if (Util.hasClass(this, "uk-active")) {
                Util.removeClass(Util.$$(".uk-navbar-toggle"), "uk-active");
                Util.removeClass(Util.$("html"), "navbar-opened");
                menuAPI.close();
            } else {
                Util.addClass(Util.$$(".uk-navbar-toggle"), "uk-active");
                Util.addClass(Util.$("html"), "navbar-opened");
                menuAPI.open();
            }
        });

        // Mobile menu collapse on screen resize
        Util.on(window, "resize", theme.Utility.debounce(function () {
            if (Util.width(window) > 1024) {
                Util.removeClass(Util.$$(".uk-navbar-toggle"), "uk-active");
                Util.removeClass(Util.$("html"), "navbar-opened");
                menuAPI.close();
            }
        }, 300, false));


        // If search button clicked, close navigation if opened
        Util.on(Util.$("#search-form-popup"), "beforeshow", function (e) {
            Util.removeClass(Util.$$(".uk-navbar-toggle"), "uk-active");
            Util.removeClass(Util.$("html"), "navbar-opened");
            menuAPI.close();
        });

        // Collapse desktop mega menu on screen resize
        Util.on(window, "resize", theme.Utility.debounce(function () {
            Util.each(Util.$$(".megamenu-panels .uk-drop"), function (item) {
                UIkit.drop(item).hide(false);
            });
        }, 300, true));
    }
};

window.theme = window.theme || {};


//window.BOLD.options.app.on('options_loaded', function(data) {
window.BOLD.options.app.on('option_products_loaded', function (data) {
    theme.Utility.replaceBoldOptionsControls(data);
})

// An option has been initialized.
window.BOLD.options.app.on('option_created', function (data) {

    // Fields decorators

    // Fields to decorate

    var fields = [
        {
            "name": "engraving_text",
            "prefix": "<label class=\"uk-form-label\">PLEASE ENTER ENGRAVING (max 14 characters)</label>",
            "suffix": "<p class=\"uk-text-small uk-margin-xsmall-top\">\n" +
                "            <strong>Note:</strong> Engraved jewellery can't be returned or exchanged, as per our <a target=\"blank\" href=\"/policies/refund-policy\">Returns Policy</a>.\n" +
                "        </p>"
        }
    ];

    var decorator = fields.filter(function (el) {
        return el.name == data.data.option.internalName
    });

    if (decorator) {

        var $el = Util.$("*[name=" + data.data.option.internalName + "]");

        // Add prefix and suffix around the field
        if (decorator.prefix) {

        }
    }
});

/* =========================== Backend section logic - Customizer ============================== */


theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    // React on event
    Util.on(document, 'shopify:section:load', this._onSectionLoad.bind(this));
    Util.on(document, 'shopify:section:unload', this._onSectionUnload.bind(this));
    Util.on(document, 'shopify:section:select', this._onSelect.bind(this));
    Util.on(document, 'shopify:section:deselect', this._onDeselect.bind(this));
    Util.on(document, 'shopify:block:select', this._onBlockSelect.bind(this));
    Util.on(document, 'shopify:block:deselect', this._onBlockDeselect.bind(this));
};


theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {

    _createInstance: function (container, constructor) {

        var $container = Util.$(container);
        var id = Util.attr($container, 'data-section-id');
        var type = Util.attr($container, 'data-section-type');

        constructor = constructor || this.constructors[type];

        if (_.isUndefined(constructor)) {
            return;
        }

        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = Util.$('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        this.instances = _.filter(this.instances, function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },

    _onSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },

    _getInstance: function (SectionId) {
        var instance = _.find(this.instances, function (instance) {
            return instance.id === SectionId;
        });
        return instance;
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;
        Util.each(Util.$$("[data-section-type=" + type + "]"), function (container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});


theme.init = function () {

    // Theme-specific selectors to make tables scrollable
    var tableSelectors = '.content table,' + '.custom__item-inner--html table',
        imageSelectors = '.static-article img,' + '.custom__item-inner--html img, .template-article .content img,.template-page .content img';

    slate.rte.wrapTable({
        $tables: Util.$$(tableSelectors),
        tableWrapperClass: 'uk-overflow-auto'
    });

    // Theme-specific selectors to make iframes responsive
    var iframeSelectors =
        '.content iframe[src*="google.com/maps/embed"],' +
        '.content iframe[src*="youtube.com/embed"],' +
        '.content iframe[src*="player.vimeo"],' +
        '.custom__item-inner--html iframe[src*="google.com/maps/embed"],' +
        '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
        '.custom__item-inner--html iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: Util.$$(iframeSelectors),
        iframeWrapperClass: 'ratio-16-9'
    });

    slate.rte.wrapImage(Util.$$(imageSelectors));
};


theme.Variants = (function () {

    /**
     * Constructor
     * @param {*} options
     */
    function Variants(options) {

        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.currentVariant = this._getVariantFromOptions();

        Util.on(Util.$$(this.singleOptionSelector, this.$container), "change", this._onSelectChange.bind(this))
    }


    Variants.prototype = _.assignIn({}, Variants.prototype, {

        /**
         * Get the currently selected options (variants) from add-to-cart form.
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {

            var currentOptions = _.map(Util.$$(this.singleOptionSelector, this.$container),
                function (el) {

                    var $el = Util.$(el);
                    var type = Util.attr($el, "type");
                    var currentOption = {};

                    if (type === 'radio' || type === 'checkbox') {
                        if ($el.checked) {
                            currentOption.value = Util.attr($el, "value");
                            currentOption.index = Util.data($el, "index");
                            return currentOption;

                        } else {
                            return false;
                        }
                    } else {
                        currentOption.value = Util.attr($el, "value");
                        currentOption.index = Util.data($el, "index");
                        return currentOption;
                    }
                });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {

            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;

            var found = _.find(variants, function (variant) {
                return selectedValues.every(function (values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },


        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {

            var variant = this._getVariantFromOptions();
            Util.trigger(this.$container, "variantChange", {variant: variant});

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;

            Util.trigger(this.$container, "variantUpdated", {variant: variant});
        },


        /**
         * Update hidden master select of variant change
         *
         * @param  {variant} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            //This is select field. Select option according to the selected value.
            var select = Util.$(this.originalSelectorId, this.$container);

            for (var index = 0; index < select.options.length; index++) {
                if (select.options[index].value == variant.id) {
                    select.selectedIndex = index;
                    break;
                }
            }
        },


        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {

            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            Util.trigger(this.$container, 'variantImageChange', {variant: variant});
        },


        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {

            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            Util.trigger(this.$container, 'variantPriceChange', {variant: variant});
        },


        /**
         * Trigger event when variant sku changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantSKUChange
         */
        _updateSKU: function (variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            Util.trigger(this.$container, 'variantSKUChange', {variant: variant});
        }
    });

    return Variants;
})();


/**
 * Features that are incommon for all product pages ( Single product page, Single Ring Sets, Single POA )
 */
theme.ProductIncommon = (function () {

    function ProductIncommon(container) {
        var $container = (this.$container = Util.$(container));
        this._init();
    }


    ProductIncommon.prototype = _.assignIn({}, ProductIncommon.prototype, {

        _init: function () {
            this.engraving();
            Util.on(Util.$$('[data-engraving-text]'), "keyup", this._checkMaxLength.bind(this));
            this.customSelectBox();
        },


        engraving: function () {

            var data_engraving_boxes = Util.$$("[data-engraving-box]", this.$container);

            Util.each(data_engraving_boxes, function (item) {
                var checkbox = Util.$('input[type="checkbox"]', item),
                    text_field = Util.$('input[type="text"]', item),
                    text_field_wrapper = text_field.parentNode;

                Util.attr(text_field, "disabled", "disabled");

                UIkit.toggle(checkbox, {
                    animation: "uk-animation-slide-bottom-small",
                    target: "#" + Util.attr(text_field_wrapper, "id")
                });

                Util.on(text_field_wrapper, "beforeshow", function () {
                    Util.removeAttr(text_field, "disabled");
                });

                Util.on(text_field_wrapper, "hidden", function () {
                    Util.attr(text_field, "disabled", "disabled");
                });
            });
        },


        customSelectBox: function (e) {
            theme.Utility.customSelectBox(e);
        },


        _checkMaxLength: function (evt) {
            var field = evt.target, v;
            v = field.value.trim();
            if (v.length > 14) {
                field.value = field.value.substr(0, 14);
            }
        }

    });
    return ProductIncommon;
})();


theme.Product = (function () {

    function Product(container) {

        var $container = (this.$container = Util.$(container));
        var sectionId = Util.data($container, "section-id");


        this.settings = {
            namespace: '.slideshow-' + sectionId,
            sectionId: sectionId
        }

        this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            SKU: '.variant-sku',
            originalSelectorId: '#ProductSelect-' + sectionId,
            productForm: '[data-product-form]',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            singleOptionSelector: '.single-option-selector-' + sectionId,
            quantity: '[data-quantity-input]',
            whishlistLink: '[data-wishlist-link]',
            enamelColor: '[data-enamel-color]',

            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',

            productSlideShow: '.single-product-slider',
            productImageWraps: '[data-slide-id]',
            productThumbImages: '.product-single__thumbnail--' + sectionId,
            productThumbs: '.uk-thumbnav-wrapper .uk-thumbnav-' + sectionId,
            productThumbListItem: '.uk-thumbnav li',
            productThumbsWrapper: '.uk-thumbnav-wrapper .uk-thumbnav',
            productFeaturedImage: '.product-featured-img'
        }

        this.$addToCart = Util.$(this.selectors.addToCart, $container);
        this.$addToCartText = Util.$(this.selectors.addToCartText, this.$addToCart);
        this.$shopifyPaymentButton = Util.$(this.selectors.shopifyPaymentButton, $container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor

        if (Util.$('#ProductJson-' + sectionId) == null) {
            return false;
        }

        var jsonStr = document.getElementById('ProductJson-' + sectionId).innerHTML;
        this.productSingleObject = JSON.parse(jsonStr);

        // Product Meta Fields
        if (Util.$('#ProductJson-' + sectionId) == null) {
            this.productSingleObject.metafields = {};
        } else {

            if (document.getElementById('ProductJsonMeta-' + sectionId)) {
                jsonStr = document.getElementById('ProductJsonMeta-' + sectionId).innerHTML;
                this.productSingleObject.metafields = JSON.parse(jsonStr);
            } else {
                this.productSingleObject.metafields = {};
            }
        }

        this._stringOverrides();
        this._initVariants();
        this._initSlideshow();
        this._initImageSwitch();
        this._initAddToCart();
        this._setActiveThumbnail();
        this._initBoldEvents();

        this._populateProductExtraVariantDropdowns();

        this._whishlistButtonInit();
        this._zoomify();
    }


    Product.prototype = _.assignIn({}, Product.prototype, {

        /**
         * @todo find a better solution to enable SUMBIT button after BOLD app finishes its magic!
         * @private
         */
        _initBoldEvents: function () {

            console.log("_initBoldEvents");

            var self = this;

            /*  window.BOLD.options.app.on('add_to_cart_cloned', function(data) {

                  // How to figure it out if "uk-disabled" class has to be removed
                  var d = data.data;
                  console.log(d);

                  var $btn = d.original;
                  if(Util.hasClass($btn, "bold_hidden") && !Util.hasClass($btn, 'uk-disabled') ){
                      Util.removeClass(Util.$$(".bold_cloned"), "uk-disabled");
                  }
              });*/
        },

        _extractTag: function (tags, tag_prefix) {
            var str = tags.join("|"),
                regex = tag_prefix + '\\-[^\\|]+',
                re = new RegExp(regex, "g"),
                x = str.match(re);

            return x == null ? '' : x[0];
        },


        _populateProductExtraVariantDropdowns: function () {

            var self = this;
            var relatedProductsCode = Util.data(Util.$("[data-product-related-code]"), "product-related-code");
            var skipGem = false;
            var url;

            console.log("_populateProductExtraVariantDropdowns");

            if (relatedProductsCode == "Product-") {
                //Util.removeClass(self.$addToCart, "uk-disabled");
                console.log("REMOVING uk disabled");
                Util.removeClass(Util.$$(self.selectors.addToCart), "uk-disabled");
                return false;
            }

            //data-parent-gem
            if (Util.$("[data-parent-gem]#product-gems-wrapper")) {
                Util.removeClass(Util.$("[data-parent-gem]#product-gems-wrapper"), "uk-hidden");
                skipGem = true;
            }

            url = "/search/?view=json&type=product&options[unavailable_products]=show&q=tag:" + relatedProductsCode;

            Util.ajax(url, {
                responseType: "json",
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then(function (xhr) {

                var dropdownType = ["metal", "gem", "enamel"];
                var output = "", r,
                    optionsContainer, optionsContainerWrapper,
                    currentProduct = self.productSingleObject,
                    usedMaterials, optionsContainer, optionsContainerWrapper, type, typeCap;

                r = xhr.response;

                if (typeof r === "string") {
                    r = JSON.parse(xhr.response);
                }

                if (r.results_total == 0) {
                    return;
                }

                for (i in dropdownType) {

                    type = dropdownType[i];
                    typeCap = type.charAt(0).toUpperCase() + type.slice(1);

                    output = "";
                    usedMaterials = [];
                    optionsContainer = Util.$("#product-" + type + "s");
                    optionsContainerWrapper = Util.$("#product-" + type + "s-wrapper");

                    if (type == 'gem' && skipGem) {
                        continue;
                    }

                    if (optionsContainer == null) continue;

                    // Filter only products that have different materials
                    var variants = r.results.filter(function (item) {
                        var material = self._extractTag(item.tags, typeCap);

                        if (material && material != "") {
                            if (usedMaterials.indexOf(material) == -1) {
                                usedMaterials.push(material);
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    });

                    if (variants.length == 0) {
                        continue;
                    }

                    // Select first meta type
                    var tmp = self._extractTag(currentProduct.tags, typeCap);

                    if (tmp) {
                        tmp = tmp.replace(typeCap + "-", "").replace(/&comma;/, ',');
                        Util.html(Util.$("[data-selected-option]", optionsContainer), tmp);
                    }

                    if (type == "metal") {
                        /**
                         *  Sort alphabetically
                         *  function(a, b){return a - b}
                         *
                         *  If the result is negative a is sorted before b.
                         *  If the result is positive b is sorted before a.
                         *  If the result is 0 no changes are done with the sort order of the two values.
                         */
                        try {
                            variants.sort(function (a, b) {
                                var a_metal = self._extractTag(a.tags, "Metal");
                                var b_metal = self._extractTag(b.tags, "Metal");

                                if (a_metal.indexOf("Sterling") > -1) {
                                    return -1;
                                } else if (b_metal.indexOf("Sterling") > -1) {
                                    return 1;
                                } else if (a_metal.indexOf("ct") > -1 && b_metal.indexOf("ct") > -1) {
                                    return (a_metal < b_metal) ? 1 : -1;
                                } else {
                                    return (a_metal < b_metal) ? -1 : ((a_metal == b_metal) ? 0 : 1);
                                }
                            });
                        } catch (error) {
                            console.log("CATCHE BLOCK", error);
                        }
                    }

                    if (variants.length == 0) {
                        return;
                    } else if (variants.length == 1) {
                        Util.addClass(Util.$("button", optionsContainerWrapper), "uk-disabled");
                    } else {
                        Util.each(variants, function (item) {
                            var match = self._extractTag(item.tags, typeCap).replace(typeCap + "-", "");
                            var metalTitle = match ? match : item.title;
                            output += '<label><input ' + (currentProduct.id == item.id ? 'checked' : '') + ' type="radio" class="uk-radio uk-hidden uk-radio-alt" value="' + item.url + '" data-title="' + metalTitle + '"><span>' + metalTitle + '</span></label>'
                        });

                        Util.html(Util.$("[data-" + type + "-options]", optionsContainer), output);

                        // Bind events
                        Util.once(optionsContainer, "change", '.redirect-on-change input[type="radio"]', function (e) {

                            Util.addClass(self.$addToCart, "uk-disabled");

                            var target = e.target;
                            var url = Util.attr(target, "value");
                            window.location.href = url;
                            return;
                        });
                    }

                    if (!Util.hasClass(optionsContainerWrapper, "skip-dropdown")) {
                        Util.removeClass(optionsContainerWrapper, "uk-hidden");
                    }
                }


                //
                // By default there is one AddToCart button but Bold Options app clones original button
                // We have to manage uk-disabled class for both buttons
                //
                if (Util.hasClass(self.$addToCart, "uk-disabled")) {
                    console.log("REMOVING uk disabled", self.selectors.addToCart);
                    Util.removeClass(Util.$$(self.selectors.addToCart), "uk-disabled");
                }
            }).catch(function (e) {
                console.log("ERROR!!! CATCH", e);
            });
        },


        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {};
            theme.strings = Object.assign(theme.strings, theme.productStrings);
        },


        _setSingleOptions: function (variant) {
            var options = variant.options, i;
            for (i in options) {
                var option = Util.$("#SingleOptionSelector-" + i + ' input[value="' + options[i] + '"].uk-radio');
                option.checked = true;
                Util.trigger(option, "change");
            }
        },


        _initVariants: function () {

            var options = {
                $container: this.$container,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };

            this.variants = new theme.Variants(options);

            // Vannila JS does not support namespaced Events

            // Bind Events
            Util.on(this.$container, 'variantChange', this._updateAvailability.bind(this));
            Util.on(this.$container, 'variantChange', this._inStock.bind(this));
            Util.on(this.$container, 'variantChange', this._updateSpecification.bind(this));
            Util.on(this.$container, 'variantChange', this._updateEngraving.bind(this));
            Util.on(this.$container, 'variantImageChange', this._updateImages.bind(this));
            Util.on(this.$container, 'variantPriceChange', this._updatePrice.bind(this));
            Util.on(this.$container, 'variantSKUChange', this._updateSKU.bind(this));


            //this.currentVariant

            this._updateStock(this.variants.currentVariant);
        },


        /**
         * Update variant id that on certain tag that are used to connect engraving with rings
         *
         * @param {*} evt
         */
        _updateEngraving: function (evt) {

            var variant = evt.detail.variant;
            if (this.productSingleObject.type != 'Ring') {
                return;
            }

            // Selectors
            var engravingBox = Util.$("[data-engraving-box]");
            var original = Util.$(this.selectors.originalSelectorId, this.container);
            var fields = Util.$$("[data-related-product]", engravingBox);

            original.setAttribute('data-variant-id', variant.id);
            Util.each(fields, function (item) {
                item.setAttribute('data-related-product', variant.id);
            });
        },


        _initSlideshow: function () {
            var opts = {
                ratio: "1:1",
                animation: "uk-animation-slide-left"
            }

            if (Util.width(window) >= $site.breakpoint) {
                opts.draggable = false;
                opts.animation = "fade";
            }
            // single-product-slider
            UIkit.slideshow(Util.$(".single-product-slider"), opts);
        },


        // Variant change handlers
        _updateAvailability: function (evt) {
            // remove error message if one is showing
            this._hideErrorMessage();

            // update form submit
            this._updateAddToCart(evt);
            // update live region
            this._updatePrice(evt);
        },


        /**
         * Update Add to Cart button
         *
         * @param {*} evt
         */
        _updateAddToCart: function (evt) {
            var variant = evt.detail.variant;

            if (variant) {
                if (variant.available) {
                    Util.removeAttr(this.$addToCart, 'disabled');
                    Util.removeAttr(this.$addToCart, 'aria-disabled');
                    Util.attr(this.$addToCart, 'aria-label', theme.strings.addToCart);
                    Util.html(Util.$(this.selectors.addToCartText, this.$container), theme.strings.addToCart);
                } else {
                    // The variant doesn't exist, disable submit button and change the text.
                    // This may be an error or notice that a specific variant is not available.
                    Util.attr(this.$addToCart, 'disabled', true);
                    Util.attr(this.$addToCart, 'aria-disabled', true);
                    Util.attr(this.$addToCart, 'aria-label', theme.strings.soldOut);
                    Util.html(Util.$(this.selectors.addToCartText, this.$container), theme.strings.soldOut)
                }
            } else {
                Util.attr(this.$addToCart, 'disabled', true);
                Util.attr(this.$addToCart, 'aria-disabled', true);
                Util.attr(this.$addToCart, 'aria-label', theme.strings.unavailable);
                Util.html(Util.$(this.selectors.addToCartText, this.$container), theme.strings.unavailable);
            }
        },


        /**
         * @param {*} evt
         */
        _updatePrice: function (evt) {

            var variant = evt.detail.variant;

            var $priceContainer = Util.$(this.selectors.priceContainer, this.$container);
            var $regularPrice = Util.$(this.selectors.regularPrice, $priceContainer);
            var $salePrice = Util.$(this.selectors.salePrice, $priceContainer);

            // Reset product price state
            Util.removeClass($priceContainer, 'product-unavailable');
            Util.removeClass($priceContainer, 'product-on-sale');
            Util.removeClass($priceContainer, 'product-sold-out');
            Util.removeAttr($priceContainer, 'aria-hidden');

            // Unavailable
            if (!variant) {
                Util.addClass($priceContainer, 'product-unavailable');
                Util.attr($priceContainer, 'aria-hidden', true);
                return;
            }

            // Sold out
            if (!variant.available) {
                Util.addClass($priceContainer, 'product-sold-out');
                //return;
            }

            // On sale
            if (variant.compare_at_price && (variant.compare_at_price > variant.price)) {
                Util.html($regularPrice, theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                Util.html($salePrice, theme.Currency.formatMoney(variant.price, theme.moneyFormat));
                Util.addClass($priceContainer, 'product-on-sale');
            } else {
                // Regular price
                Util.html($regularPrice, theme.Currency.formatMoney(variant.price, theme.moneyFormat));
            }
        },


        _updateSKU: function (evt) {
            var variant = evt.detail.variant,
                product = this.productSingleObject, sku;

            sku = theme.Utility.formatSKU(product.type, variant.sku);
            Util.html(Util.$(this.selectors.SKU), sku);
        },


        _updateSpecification: function (evt) {

            var variant = evt.detail.variant,
                meta = this.productSingleObject.metafields,
                bingo = [];
            if (meta.variants) {
                bingo = meta.variants.filter(function (item) {
                    return variant.id == item.id;
                });
            }
            if (bingo.length > 0) {
                if (bingo[0].ring_width) {
                    Util.each(Util.$$("[data-ring-width]"), function (item) {
                        Util.html(item, bingo[0].ring_width);
                    });
                }
            } else if (meta["specs.ring_width"]) {
                Util.each(Util.$$("[data-ring-width]"), function (item) {
                    Util.html(item, meta["specs.ring_width"]);
                });
            }

            // Update Enamel color field
            if (Util.$(this.selectors.enamelColor) && variant.option2 != null) {
                Util.html(Util.$(this.selectors.enamelColor), variant.option2);
            }
        },


        _initImageSwitch: function () {

            if (!Util.$$(this.selectors.productThumbListItem).length) {
                return;
            }

            var self = this;

            /**
             * On image change in the product slider update variant data in dropdowns, price, SKU etc.
             */
            Util.on(Util.$$(this.selectors.productThumbListItem + " a"), "click", function (evt) {

                evt.preventDefault();
                var $el = evt.currentTarget;
                var variantIds = Util.data($el, "variant-id");
                var product = self.productSingleObject;
                var variant = {};

                /**
                 * Calculate corrent variant according to the clicked image.
                 * Correct variant should meet following conditions:
                 *
                 * 1. Filter all variants that have clicked image.
                 * 2. Further filter all variants that have already assigned SIZE and ENAMEL (colour)
                 *
                 * As a result we should endup with one available variant.
                 * If there are no available variants
                 *
                 */

                if (!variantIds) {
                    return;
                }

                // Get all options for currently selected variant

                var cOptions = self.variants._getCurrentOptions();
                var cVariants = self.variants._getVariantFromOptions();

                /**
                 * Find first variant with current size
                 */

                /**
                 *  Convert to integers. Keep in mind that variantId can hold multiple variants
                 *  because an image can be associated with mutiple variants.
                 */
                variantIds = variantIds.split(",").map(function (item) {
                    return parseInt(item, 10);
                });

                var result = [];
                for (var vIndex in variantIds) {
                    result = product.variants.filter(function (v) {
                        return (v.id == variantIds[vIndex] && v.option1 == cVariants.option1)
                    });
                    if (result.length > 0) {
                        break;
                    }
                }

                if (result.length > 0) {
                    variant = result[0];
                } else {
                    // Fetch first variant that match variant ID
                    for (var variantIndex in product.variants) {
                        if (variantIds.indexOf(product.variants[variantIndex].id) > -1) {
                            variant = product.variants[variantIndex];
                            break;
                        }
                    }
                }

                if (!variant) {
                    return;
                }

                self._setSingleOptions(variant);
            });
        },


        /**
         * @param {*} evt
         */
        _updateImages: function (evt) {
            var variant = evt.detail.variant;
            var imageId = variant.featured_image.id;

            this._switchImage(imageId);
            //this._setActiveThumbnail(imageId);
        },


        /**
         * Show selected image in the slider ( Goto to a slide with provided imageId )
         *
         * @param {*} imageId
         */
        _switchImage: function (imageId) {

            // Find slide by image id
            var $slider = Util.$(this.selectors.productSlideShow, this.$container);
            var new_slide = Util.$$(this.selectors.productImageWraps, $slider).filter(function (slide) {
                return (imageId == Util.data(slide, "slide-id"))
            });
            UIkit.slideshow($slider).show(Util.data(new_slide[0], "index"));
        },


        /**
         * Update slider's active slide according to the the selected variant
         *
         * Set active slide
         */
        _setActiveThumbnail: function (imageId) {

            // Find out what is the current variant
            if (typeof imageId === 'undefined') {
                if (this.variants.currentVariant.featured_image) {
                    imageId = this.variants.currentVariant.featured_image.id
                }
            }

            if (imageId) {
                var $slider = Util.$(this.selectors.productSlideShow, this.$container);
                var new_slide = Util.$$(this.selectors.productImageWraps, $slider).filter(function (slide) {
                    return (imageId == Util.data(slide, "slide-id"))
                });
                UIkit.slideshow($slider).show(Util.data(new_slide[0], "index"));
            }

            return;
        },


        /**
         * If main image clicked show slider in modal box
         */
        _zoomify: function () {

            // Click on Featured image

            var self = this;

            //data-slide-id
            Util.on(Util.$$("[data-slide-id]", Util.$(".product-section-wrapper")), "click", function (env) {

                // Prevent Video Zoom if player clicked
                if (env.target == "video") {
                    return false;
                }

                if (Util.width(window) < 768) {
                    return false;
                }

                if (Util.$("[data-product-slideshow-modal]") == null) {

                    var modal = document.createElement("div");
                    var modalDialog = document.createElement("div");
                    var slideshow = Util.$(self.selectors.productSlideShow).cloneNode(true);

                    Util.attr(slideshow, "data-uk-slideshow", "animation:uk-animation-slide-left; ratio: 1:1");

                    Util.each(Util.$$('figure', slideshow), function (item) {
                        Util.removeClass(item, 'ratio-1-1');
                    });

                    Util.addClass(modalDialog, "uk-modal-dialog", "uk-margin-auto-vertical");
                    Util.addClass(modal, "uk-modal-full");
                    Util.attr(modal, "id", "slideshow-modal");
                    Util.attr(modal, "data-uk-modal", "");
                    Util.attr(modal, "data-product-slideshow-modal", "");
                    Util.html(modalDialog, slideshow);
                    Util.append(modal, modalDialog);
                    Util.prepend(modal, '<button type="button" class="uk-modal-close-full uk-close-large" data-uk-close aria-label="CLOSE MODAL"></button>');
                    Util.append(Util.$("body"), modal);
                }
                UIkit.modal(Util.$("[data-product-slideshow-modal]")).show();
            });
        },


        /**
         * Add to cart button
         */
        _initAddToCart: function () {

            var self = this,
                callback = function () {
                    var modal = [
                        '<div class="uk-position-top uk-width-1-1 uk-z-index-10">',
                        '<div class="uk-alert uk-alert-success uk-alert-yellow" data-uk-alert>',
                        '<div class="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle">',
                        '<div>',
                        '<p>You added this product to your shopping bag.&nbsp;&nbsp;&nbsp;&nbsp;</p>',
                        '</div>',
                        '<div>',
                        '<a href="/cart" class="uk-button uk-button-small uk-button-outline"><span>View bag and checkout</span></a>&nbsp;&nbsp;&nbsp;&nbsp;',
                        '<a href="#" data-uk-close class="uk-alert-close" arial-label="Close Popup"></a>',
                        '</div>',
                        '</div>',
                        '</div>',
                        '</div>'
                    ].join("");

                    Util.prepend(Util.$(".product-section-wrapper"), modal);
                    $site.buttonAnims(".uk-alert");
                    UIkit.scroll('#top').scrollTo('#top');
                }


            /**
             * On Cart form submit
             */
            Util.on(Util.$(this.selectors.productForm, this.$container), "submit", function (evt) {

                console.log("!!!NORMAL PRODUCT SUBMIT!!!");

                evt.preventDefault();

                if (Util.hasAttr(this.$addToCart, "aria-disabled")) {
                    return;
                }

                console.log("!!!PASSED 1");

                // Validate engraving
                // var product_id = Util.data(Util.$("#ProductSelect-product-template"), "product-id");
                var checkbox = Util.$("input[name='properties[Engraving]']"), text = "";

                console.log("!!!PASSED 2");

                if (Util.$("input[name='properties[Engraving Text]']")) {
                    text = Util.$("input[name='properties[Engraving Text]']").value.trim();
                }

                console.log("!!!PASSED 3");

                if (checkbox != null && checkbox.value && text == "") {
                    theme.Utility.dialog('Engraving text is missing.', 'uk-alert-warning');
                    return false;
                }

                console.log("!!!PASSED 4");

                var $form = Util.$(this.selectors.productForm, this.$container);
                var form_data = theme.Utility.normalizeProductFormData($form, this.productSingleObject);


                console.log("NORM<ALIZE DATA", form_data);

                // disable the addToCart and dynamic checkout button while
                // request/cart popup is loading and handle loading state
                this._handleButtonLoadingState(true);

                this._addAllItemsToCart(form_data, function (response) {
                    Util.trigger(Util.$("body"), 'updateCart', {data: response});
                    callback();
                });

            }.bind(this));
        },


        /**
         * Recursive function to add all products into the cart
         */
        _addAllItemsToCart: function (products, callback) {

            var p = products, added = [];

            Shopify.queue = products;

            if (products.length == 0) {
                return;
            }

            Shopify.moveAlong = function () {
                if (Shopify.queue.length > 0) {

                    var request = Shopify.queue.pop();
                    var data = {
                        id: request.id,
                        quantity: 1,
                        form_type: "product",
                        utf8: "%E2%9C%93"
                    };

                    for (prop in request.properties) {
                        data['properties[' + prop + ']'] = request.properties[prop];
                    }

                    data = theme.Utility.serialize(data);

                    var params = {
                        method: "POST",
                        data: data,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    };

                    Util.ajax("/cart/add.js", params)
                        .then(function (xhr) {
                            // Add item to Popup cart
                            added.push(JSON.parse(xhr.response));
                            Shopify.moveAlong();
                        })
                        .catch(function () {
                            if (Shopify.queue.length) {
                                Shopify.moveAlong()
                            }
                            console.log("CATCH ERROR!", arguments);
                        });
                } else {
                    callback(added);
                }
            }
            Shopify.moveAlong();
        },


        /**
         * @param {*} isLoading
         */
        _handleButtonLoadingState: function (isLoading) {
            if (isLoading) {
                Util.attr(this.$addToCart, 'aria-disabled', true);
                Util.attr(this.$shopifyPaymentButton, 'disabled', true);
            } else {
                Util.removeAttr(this.$addToCart, "aria-disabled");
                Util.removeAttr(this.$shopifyPaymentButton, "disabled");
            }
        },


        /**
         * Logika je sledeca:
         *
         * Uzmi trenutni option1 -> update option 2,3
         *      trenutni option2 -> update option 1,3
         *
         */
        _updateStock: function (currentVariant) {

            var p = this.productSingleObject;
            var variants = p.variants;
            var currentOptions = currentVariant.options;

            var len = currentOptions.length;
            var o, found, filtered = [];

            if (currentVariant.option1 == 'Default Title' || p.variants.length < 2) {
                // This is a product without variants.
                return;
            }

            for (var i = 0; i < len; i++) {

                o = "option" + (i + 1);
                v = currentOptions[i];
                found = [];

                // Find all variants that have indentical values for all options except for the current option (o)

                if (len == 1) {
                    // return all variants (it means all variant has to have calculated stock levels)
                    filtered = variants;
                } else {

                    // Skontaj po kojim parametrima treba sa se poredi

                    // Clone array
                    var ops = currentOptions.map(function (x) {
                        return x;
                    });
                    ops.splice(i, 1);

                    found = variants.filter(function (item) {
                        // varianta ima N opcija / tekuca opcija je K
                        // Uporedi opcije:
                        // k=0 => k+1 do n
                        // k=n => 0 do n-1
                        // 0<k<n => (0 do k-1) i (k+1 do n)
                        return ops.every(function (x) {
                            return item.options.includes(x);
                        });
                    });
                }

                // Merge arrays of objects
                Array.prototype.push.apply(filtered, found);

                // Remove duplicates if any
                // Filtered variants for which we have to set Stock levels
                filtered = filtered.filter(function (item, pos, filtered) {
                    return filtered.map(function (mapItem) {
                        return mapItem["id"];
                    }).indexOf(item["id"]) === pos;
                });
            }

            // Update stock levels
            var optionSelectors = Util.$$('*[id^="SingleOptionSelector"] .uk-radio');
            var $form = Util.$(this.selectors.productForm, this.$container);

            // Clear all stock levels
            Util.each(optionSelectors, function (item) {
                Util.$(".inventory-quantity", item.parentNode).innerText = "";
            });

            var isPOA = this.productSingleObject.tags.indexOf("POA") > -1;
            var select = Util.$("*[name='id']");
            var self = this;

            if (currentVariant.inventory_management && isPOA && !currentVariant.available || !currentVariant.inventory_management && isPOA) {
                Util.addClass($form, 'outOfStock');
            } else if (currentVariant.inventory_management && currentVariant.available || !currentVariant.inventory_management && !isPOA) {
                Util.removeClass($form, 'outOfStock');
            }


            // Filtered variants for which we have to set Stock levels
            Util.each(filtered, function (variant) {

                var q = self._getQuantityByVariant(variant);
                q = parseInt(q);

                if (variant.available && q > 0 && variant.inventory_management) {

                    // Show Stock data in a single variant selector
                    var fields = self._findSingleOptionFieldsByVariant(variant);
                    var optionTagsNoCurrentVariant = [];

                    if (variant.options.toString() == currentVariant.options.toString()) {

                        Util.each(variant.options, function (o) {
                            Array.prototype.push.apply(optionTagsNoCurrentVariant, fields.filter(function (ii) {
                                var inner = Util.$(".uk-radio", ii);
                                return Util.attr(inner, "value") == o;
                            }));
                        });
                    } else {
                        Util.each(variant.options, function (o) {
                            if (!currentVariant.options.includes(o)) {
                                // update option
                                Array.prototype.push.apply(optionTagsNoCurrentVariant, fields.filter(function (ii) {
                                    var inner = Util.$(".uk-radio", ii);
                                    return Util.attr(inner, "value") == o;
                                }));
                            }
                        });
                    }

                    Util.each(optionTagsNoCurrentVariant, function (field) {
                        var f = Util.$(".uk-radio", field);
                        Util.$(".inventory-quantity", field).innerText = " (" + q + " in Stock)";
                    });
                }
            });
        },


        /**
         * Set Stock level by variant options.
         *
         * Products with inventory tracking switched off
         *    - behaviour as current
         *
         * Products with inventory tracking switched on
         *    - If selected variant has stock then show price, available quantity in dropdown option and 'Add to bag' button
         *    - Otherwise, if variant has zero stock and product has POA tag then display POA instead of price and 'Enquire Now' button
         *    - Otherwise, if variant has zero stock and no POA tag then display price and 'Add to bag' button as normal.
         */
        _inStock: function (evt) {
            var variant = evt.detail.variant;
            this._updateStock(variant);
        },


        /**
         * Returns variant quantity
         *
         * @param v variant
         */
        _getQuantityByVariant: function (v) {

            // Find variant accrding to the provided options
            var select = Util.$("*[name='id']");
            var option = Util.$('option[value="' + v.id + '"]', select);


            if (option) {
                return Util.data(option, "inv-qty");
            } else {
                return null;
            }
        },

        /**
         * Return an HTML tag that represent single variant
         * @param {*} options
         */
        _findOptionTag: function (options) {

            var singleSelectors = Util.$$('*[id^="SingleOptionSelector"]');
            var ops = [];

            for (var i = 0; i < options.length; ++i) {
                ops.push(Util.$('input[value="' + options[i].value + '"]', singleSelectors[i]).parentNode);
            }

            return ops;
        },


        _findSingleOptionFieldsByVariant: function (v) {
            // Convert variant to options
            var o = v.options;
            var options = [], r;

            for (var i = 0; i < o.length; i++) {
                options.push({"value": o[i], "index": "index" + (i + 1)})
            }
            return this._findOptionTag(options)
        },


        /**
         * Add product to a whishlist
         *
         * This code executes only on the single products page
         */
        _whishlistButtonInit: function () {

            var $link = Util.$(this.selectors.whishlistLink, this.$container);

            function swymCallbackFn() {
                _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
            }

            function fetchCallbackFn(products) {
                var activeProductId = SwymPageData.empi,
                    activeVariantId = SwymPageData.epi;
                var isInWishlist = products.find(function (p) {
                    return p.empi == activeProductId && p.epi == activeVariantId;
                });
                if (isInWishlist) {
                    $link.setAttribute("disabled", true);
                    $link.innerHTML = "Added to Wish List";
                } else {
                    Util.on($link, "click", function (e) {
                        var wishlistButton = e.target;
                        e.preventDefault();
                        if (SwymPageData) {
                            SwymPageData.et = 4;  // et 4 stands for wishlist event type
                            _swat.addToWishList(SwymPageData, function (e) {
                                wishlistButton.innerHTML = "Added to Wish List";
                                Util.addClass(wishlistButton, "uk-disabled");
                                Util.attr(wishlistButton, "disabled", true);
                            });
                        }
                    });
                }
            }

            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
        },


        _showErrorMessage: function (errorMessage) {
        },


        _hideErrorMessage: function () {
        },


        onUnload: function () {
            Util.off(this.$container, this.settings.namespace);
        }
    });

    return Product;
})();


theme.PopupCart = (function () {

    function PopupCart(container) {

        this.container = Util.$(container);

        selectors = {
            cartPopup: '[data-cart-popup]',
            cartCloseButton: '[data-cart-popup-close]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupForm: '[data-cart-popup] form',
        }

        this.$cartPopup = Util.$(selectors.cartPopup);
        this.$cartCloseButton = Util.$(selectors.cartCloseButton);
        this.$cartPopupForm = Util.$(selectors.cartPopupForm);
        this.$cartPopupQuantity = Util.$(selectors.cartPopupQuantity);
        this.$cartPopupContainer = Util.$("#CartContainer");
        this.$cartPopupItems = Util.$("#CartContainer > .uk-card-product");

        this._init();
    }


    PopupCart.prototype = _.assignIn({}, PopupCart.prototype, {

        self: this,

        _init: function () {

            var self = this;

            // Bind submit product form event handler
            if (Util.$("[data-product-form]")) {
                this._formOverride();
            }

            Util.on(this.$cartPopup, "click", "[data-remove-item]", this._removeCartEntry.bind(this));
            Util.on(this.$cartCloseButton, "click", this._close.bind(this));
            Util.on("body", "updateCart", this._updateCart.bind(this));
        },


        _updateCart: function (evt) {
            this._getCart(this._cartUpdateCallback.bind(this));
        },


        // Get the content of the Cart and call callback function
        _getCart: function (callback) {
            var params = {};
            Util.ajax("/cart.js", params)
                .then(
                    function (xhr) {
                        if (typeof callback === "function") {
                            callback(xhr.response);
                        }
                    }
                );
        },


        /**
         * @param cart Object
         */
        _cartUpdateCallback: function (cart) {

            console.log("CART UPDATE - _cartUpdateCallback", cart);

            var output = '<p>Cart is empty.</p>';

            if (typeof cart === 'string') {
                cart = JSON.parse(cart);
            }

            if (window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function') {

                console.log("FIX CART!");
                cart = BOLD.common.cartDoctor.fix(cart);
            }

            this._updateCountPrice(cart);

            // render products
            if (cart.item_count > 0) {

                output = '';
                var item, properties = [], options, variant_options, line_index;

                for (var k = 0; k < cart.items.length; k++) {

                    item = cart.items[k];
                    properties = [],
                        options_str = '',
                        variant_options = [];
                    line_index = k + 1;

                    var classes = [];
                    classes.push(item.product_type.toLowerCase());

                    /**
                     * Add/Get additional attributes
                     */
                    var attrs = [];
                    for (var property_name in item.properties) {
                        // Skip props with undescore. These are used only for the print report
                        if (property_name.indexOf("Engraving") >= 0) {
                            attrs.push("data-has-engraving");
                        }
                        if (property_name.indexOf("Part of") >= 0) {
                            attrs.push('data-ringset');
                        }
                        if (property_name.indexOf("_ringset_sku") >= 0) {
                            attrs.push('data-ringset-group="' + item.properties[property_name] + '"');
                        }
                        /* if(property_name.indexOf("_related_product_id") >= 0){
                             attrs.push('data-related-product="' + item.properties[property_name] + '"');
                         }*/
                    }


                    // If a product has more than one variant show/get variant's data
                    if (!item.product_has_only_default_variant) {
                        for (var i = 0; i < item.options_with_values.length; i++) {
                            var temp = item.options_with_values[i];
                            if (temp.name == 'Size') {
                                continue;
                            }
                            variant_options.push('<li data-cart-item-option>' + temp.name + ': ' + temp.value + '</li>');
                        }
                        options_str = variant_options.join("");
                    }

                    // Render property of a product is a part of a Ringset)
                    for (var property_name in item.properties) {
                        // Skip property if it starts with "_"
                        if (property_name.indexOf("_") === 0) {
                            continue;
                        }

                        if (property_name.indexOf("Part of") > -1 && item.properties[property_name]) {
                            properties.push('<li data-cart-item-property><span class="product-details__item-label" data-cart-item-property-name>' + property_name + ': </span><span data-cart-item-property-value>' + item.properties[property_name] + '</span></li>');
                        }
                    }

                    // Render products properties (Metal, Gemstone and Enamel)
                    for (var property_name in item.properties) {
                        // Skip property if it starts with "_"
                        if (property_name.indexOf("_") === 0) {
                            continue;
                        }

                        if (property_name.indexOf("Part of") === -1 && item.properties[property_name]) {
                            properties.push('<li data-cart-item-property><span class="product-details__item-label" data-cart-item-property-name>' + property_name + ': </span><span data-cart-item-property-value>' + item.properties[property_name] + '</span></li>');
                        }
                    }

                    if (properties.length > 0) {
                        options_str += properties.join("");
                    }

                    if (item.product_type == 'Service' && item.handle == 'engraving') {
                        classes.push("engraving");
                    }

                    /* if(item.product_type == 'Service' && item.handle == 'gift-wrapping'){
                         classes.push("gift-wrapping");
                         //gift_wrapping_count++;
                     }*/

                    output += [
                        '<div ' + attrs.join(' ') + ' data="' + item.product_type + '" id="product_' + item.id + '" class="uk-card uk-card-product '
                        + classes.join(" ") + '" data-cart-item-index="' + line_index + '" '
                        + ' data-cart-item data-cart-item-key="' + item.key + '" data-cart-item-title="' + item.product_title + '" data-cart-item-quantity="' + item.quantity + '">',
                        '<div class="uk-card-media-left">',
                        '<div class="ratio-1-1" data-cart-popup-image-wrapper>',
                        '<img data-src="' + item.featured_image.url + '" alt="' + item.featured_image.alt + '" data-cart-item-image data-uk-cover data-uk-img>',
                        '<a href="' + item.url + '" class="read-more" aria-label="' + item.product_title + '"></a>',
                        '</div>',
                        '<div class="bottom-bar uk-visible@s">',
                        '<!-- <a id="update-order-item-small-id2" href="#" class="update-order-item" aria-label="Edit Item"><i class="icon-art-and-design"></i><small>Edit item</small></a> -->',
                        '</div>',
                        '</div>',
                        '<div class="uk-card-body uk-width-expand">',
                        '<div class="description">',
                        '<h2 class="uk-card-title" data-cart-popup-title>' + (item.product_type.toLowerCase() != 'service' ? '<a href="' + item.url + '">' + item.product_title + '</a>' : item.product_title) + '</h2>',
                        '<ul class="uk-card-meta">',
                        options_str,
                        '</ul>',
                        '</div>',
                        '</div>',
                        '<div class="uk-card-footer">',
                        '<div class="tools">',
                        '<div class="uk-text-right">',
                        '<div class="uk-flex uk-flex-right">',
                        (item.product_type.toLowerCase() != 'service' ? '<a class="uk-icon-button btn-tool" arial-label="Remove Item" data-remove-item="' + item.id + '" href="#"><i class="icon-garbage"></i></a>' : ''),
                        '</div>',
                        '<small class="uk-card-meta price"><strong data-cart-popup-price>' + theme.Currency.formatMoney(item.final_line_price, theme.moneyFormat) + '</strong></small>',
                        '</div>',
                        '</div>',
                        '</div>',
                        '</div>'
                    ].join("");
                }

                Util.removeClass(Util.$("[data-cart-count-bubble]"), "uk-hidden");
            }

            Util.html(this.$cartPopupContainer, output);

            if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
            }
        },


        _formOverride: function () {
        },


        _updateCountPrice: function (cart) {
            var n = cart.items.length, services;
            Util.html(Util.$("[data-cart-popup-cart-quantity]"), n + " ");
            Util.html(Util.$("[data-cart-count]"), n + " ");
            Util.html(Util.$("#cart-small-popup [data-cart-item-regular-price]"), theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
        },


        // Close popup
        _close: function (e) {
            e.preventDefault();
            var target = e.currentTarget;
            UIkit.dropdown(Util.$("#cart-small-popup")).hide();
        },


        _removeCartEntry: function (e) {

            e.preventDefault();

            var target = e.target, self = this;
            var product_card = target.closest("[data-cart-item]");
            var lineToDeleteIndex = Util.data(product_card, "cart-item-index");
            var linetoDeleteQuantity = parseInt(Util.data(product_card, "cart-item-quantity"));
            var ringsetGroup = Util.data(product_card, "ringset-group"), data = {};
            var index, q, currentGroup, params;
            var hasWrapping = Util.data(product_card, "wrapped-bundle");

            data.updates = [];

            if (ringsetGroup) {

                var ringsetEntries = Util.$$('#CartContainer [data-ringset-group="' + ringsetGroup + '"]');
                var ringsetEntriesWithEngraving = ringsetEntries.filter(function (item) {
                    return item.hasAttribute("data-has-engraving");
                });

                var ringSetQuantity = 0;
                /**
                 * Calculate quantity of the ring set
                 */
                for (var i = 0; i < ringsetEntries.length; i++) {
                    ringSetQuantity = ringSetQuantity + parseInt(Util.data(ringsetEntries[i], "cart-item-quantity"));
                }

                var giftWrappingUpdated = false;

                Util.each(Util.$$("#CartContainer > *"), function (item) {

                    index = parseInt(Util.data(item, "cart-item-index"));
                    q = parseInt(Util.data(item, "cart-item-quantity"));
                    currentGroup = Util.data(item, "ringset-group");

                    if (lineToDeleteIndex == index || (currentGroup != null && ringsetGroup == currentGroup)) {
                        data.updates.push(0);
                    } else {
                        //Todo Check of this line is related to the main line.
                        if (Util.hasClass(item, 'engraving')) {
                            // Calculate how many engravings are assigned to a ring set
                            data.updates.push(q - ringsetEntriesWithEngraving.length);
                        } else if (Util.hasClass(item, 'gift-wrapping') &&
                            !giftWrappingUpdated &&
                            wrappedRingset.length > 0) {
                            data.updates.push(q - 1);
                            giftWrappingUpdated = true;
                        } else {
                            data.updates.push(q);
                        }
                    }
                });

            } else {

                Util.each(Util.$$("#CartContainer > *"), function (item) {

                    index = parseInt(Util.data(item, "cart-item-index"));
                    q = parseInt(Util.data(item, "cart-item-quantity"));

                    if (lineToDeleteIndex == index) {
                        data.updates.push(0);
                    } else {
                        //Todo Check of this line is related to the main line.
                        if (product_card.hasAttribute("data-has-engraving") && Util.hasClass(item, 'engraving')) {
                            data.updates.push(q - linetoDeleteQuantity);
                        } else {
                            data.updates.push(q);
                        }
                    }
                });
            }

            params = {
                method: "POST",
                data: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            };

            Util.ajax("/cart/update.js", params).then(function (xhr) {

                // Remove entry from DOM
                if (window.location.href.indexOf("/cart") > -1) {
                    location.href = '/cart'
                } else {
                    self._getCart(self._cartUpdateCallback.bind(self));
                }
            }).catch(function () {
                console.log(arguments);
            });
        }
    });

    return PopupCart;

}());


/**
 * Decorate injected newsletter form
 */
theme.NewsletterForm = (function () {


    function NewsletterForm(container) {
        var $container = (this.$container = Util.$(container));
        this.selectors = {
            radioButtons: '.uk-radio',
            submit: 'input[type="submit"]',
            textFields: 'input[type="text"]',
            emailField: '#mailing-list-modal #mce-EMAIL',
            fakeEmailField: '#fake-email-field',
            fakeSubscribe: '.fake-subscribe-button'
        }

        this.$radioButtons = Util.$$(this.selectors.radioButtons);
        this.$textFields = Util.$$(this.selectors.textFields);
        this.$submit = Util.$(this.selectors.submit);
        this.$emailField = Util.$(this.selectors.emailField);
        this.$fakeEmailField = Util.$(this.selectors.fakeEmailField);
        this.$fakeSubscribe = Util.$(this.selectors.fakeSubscribe);
        this._init();
    }


    NewsletterForm.prototype = _.assignIn({}, NewsletterForm.prototype, {

        _init: function () {

            var self = this;
            // Events
            Util.on(self.$fakeSubscribe, "click", function (env) {
                Util.attr(self.$emailField, "value", self.$fakeEmailField.value);
            });
        }
    });
    return NewsletterForm;
})();


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */
theme.Currency = (function () {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();


theme.CurrencySelector = (function () {

    var selectors = {
        form: "form",
        select: 'select[name="currency"]',
        options: 'input.uk-radio'
    };


    function CurrencySelector(container) {

        this.$containers = Util.$$(container);
        var $container, form, options;

        for (var i = 0; i < this.$containers.length; i++) {
            $container = this.$containers[i];
            form = Util.$(selectors.form, $container);
            options = Util.$$(selectors.options, $container);
            // Bind Events
            Util.on(options, "change", this.onChange.bind(this));
        }
    }


    CurrencySelector.prototype = _.assignIn({}, CurrencySelector.prototype, {

        onChange: function (evt) {
            var select;
            var target = evt.target, selectedValue, options, form;
            selectedValue = target.value;
            form = Util.$("form", target.parentNode.parentNode.parentNode);
            select = Util.$('select[name="currency"]', form);

            options = select.options;

            for (var opt, j = 0; opt = options[j]; j++) {
                //If the option of value is equal to the option we want to select.
                if (opt.value == selectedValue) {
                    //Select the option and break out of the for loop.
                    select.selectedIndex = j;
                    break;
                }
            }
            form.submit();
        }
    });
    return CurrencySelector;
})();


theme.ProductRecommendations = (function () {

    function ProductRecommendations(container) {
        var $container = this.$container = Util.$(container);
        this.recommendationContainer = Util.$(".uk-grid", $container);// not in use at the moments
        this._init();
    }

    ProductRecommendations.prototype = _.assignIn({}, ProductRecommendations.prototype, {
        _init: function () {
            self = this;
            var productId = Util.data(this.$container, 'product-id');
            var limit = Util.data(this.$container, 'limit');
            var productRecommendationsUrl =
                '/recommendations/products?&section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

            Util.ajax(productRecommendationsUrl, {
                method: 'GET',
                responseType: 'text'
            }).then(function (xhr) {
                if (xhr.status === 404 || xhr.status === 422) {
                    Util.remove(self.$container);
                }

                var html = document.createElement("div");
                html.innerHTML = xhr.response;
                var grid_only = Util.$$(".recommendation-grid > *", html);
                Util.html(Util.$(".recommendation-grid", self.$container), grid_only);
            }).catch(function () {
                console.log(arguments);
                Util.remove(Util.$("#shopify-section-product-recommendations"));
            });
        },
    });
    return ProductRecommendations;
})();


theme.ProductRecent = (function () {

    var selectors = {
        slider_container: "[data-recent-products-container]",
        slider: "[data-uk-slider-recent]"
    };

    function ProductRecent(container) {
        var $container = this.$container = Util.$(container);
        //this.$slider_container = Util.$(selectors.slider_container, $container);
        this.$slider = Util.$(selectors.slider, $container);
        // This is a place to bind any events if needed
        this._init();
    }


    ProductRecent.prototype = _.assignIn({}, ProductRecent.prototype, {

        _init: function () {
            // number of items to show
            this.limit = Util.data(this.$container, "limit");
            // How many items should be stored in the cookie
            this.limitInMemory = 10;
            this.sectionId = Util.data(this.$container, "section-id");
            this.configuration = {
                expires: 90,
                path: '/',
                domain: window.location.hostname
            };

            this.productHandleQueue = [];
            this._showRecentlyViewed();
            this._recordRecentlyViewed();
        },

        _showRecentlyViewed: function () {

            var self = this;

            // Read cookie.
            this.productHandleQueue = this.read();
            if (this.productHandleQueue.length == 0) {
                return;
            }

            var loadEntry = function () {
                if (self.productHandleQueue.length > 0) {
                    var request = self.productHandleQueue.shift();

                    Util.ajax('/products/' + request + '.js', {
                        responseType: "json",
                        headers: {
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function (xhr) {
                        var r = xhr.response;
                        if (typeof r === 'string') {
                            r = JSON.parse(xhr.response);
                        }

                        if (xhr.status === 404 || xhr.status === 422) {
                            //alert("ERROR 404");
                        } else {
                            if (r.type != "Service") {
                                Util.append(Util.$("[data-recent-products-container]"), "<li>" + theme.Utility.renderProduct(r) + "</li>");
                            }
                            loadEntry();
                        }
                    }).catch(function () {
                        console.log("CATCH: ", arguments);
                        if (self.productHandleQueue.length > 0) {
                            self.remove(request);
                            loadEntry()
                        }
                    });
                } else {
                    self._finalize();
                }
            }

            // If we have any to show.
            loadEntry();
        },

        _finalize: function () {
            Util.removeClass(this.$container, "uk-hidden")
            UIkit.slider(Util.$("[data-uk-slider-recent]", this.$container));
        },

        _recordRecentlyViewed: function (params) {

            // Read cookie.
            var recentlyViewed = this.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {

                // What is the product handle on this page.
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                // In what position is that product in memory.
                var position = recentlyViewed.indexOf(productHandle);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, this.limitInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                this.write(recentlyViewed);
            }
        },

        read: function () {
            var recentlyViewed = [];
            var cookieValue = Cookies.get(this.sectionId);
            if (cookieValue !== null && typeof cookieValue != "undefined") {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },

        write: function (recentlyViewed) {
            Cookies.set(this.sectionId, recentlyViewed.join(' '), this.configuration);
        },

        clearAll: function () {
            Cookies.set(this.sectionId, null, this.configuration);
        },


        remove: function (productHandle) {
            var recentlyViewed = this.read();
            var position = recentlyViewed.indexOf(productHandle);//jQuery.inArray(productHandle, recentlyViewed);

            if (position > -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    });

    return ProductRecent;
})();


theme.Utility = {


    getUsableHeight: function () {

        "use strict";

        // check if this page is within a app frame
        var isInAppMode = ("standalone" in navigator && navigator.standalone) || (window.chrome && window.top.chrome.app && window.top.chrome.app.isInstalled);

        var ua = navigator.userAgent;
        // memoized values
        var isIphone = ua.indexOf('iPhone') !== -1 || ua.indexOf('iPod') !== -1;
        var isIpad = ua.indexOf('iPad') !== -1;
        var isAndroid = ua.indexOf('Android') !== -1;
        var isMobile = isIphone || isIpad || isAndroid;

        // compute the missing area taken up by the header of the web browser to offset the screen height
        var usableOffset = 0;
        if (isIphone) {
            usableOffset = 50;
        } else if (isAndroid && ua.indexOf('Chrome') === -1) {
            usableOffset = 1;
        }

        return function () {

            if (!isMobile) {
                return window.innerHeight;
            }
            var isLandscape = window.innerWidth > window.innerHeight, height;
            // on ios devices, this must use screen
            if (isIphone) {
                height = isLandscape ? screen.width : screen.height;
                if (!isInAppMode) {
                    height -= isLandscape ? 32 : 44; // status bar
                    height += 1;
                    height -= 80; // Bottom bar
                }
            } else {
                //height = (isLandscape ? window.outerWidth : window.outerHeight) / (window.devicePixelRatio || 1);
                height = (isLandscape ? window.outerWidth : window.outerHeight);
                height -= 0; // Bottom bar
            }
            return height - usableOffset;
        }
    },


    loadingScreen: function () {

        Util.once("body", "hideLoadingScreen", function (e) {
            UIkit.modal(Util.$("#loading-screen")).hide();
            setTimeout(function () {
                Util.$("#loading-screen").parentNode.removeChild(Util.$("#loading-screen"));
            }, 300)
        });

        var modal = [
            '<div id="loading-screen" class="uk-width-1-1 uk-z-index-10">',
            '<div class="uk-position-center">',
            '<div class="uk-text-center">',
            '<p class="uk-light uk-text-lead">Updating<div class="dot one">.</div><div class="dot two">.</div><div class="dot three">.</div></p>',
            '</div>',
            '</div>',
            '</div>'
        ].join("");

        UIkit.modal(modal).show();
    },


    formatSKU: function (productType, sku) {
        var parts = [];

        if (productType == "Ring") {
            sku = sku.substring(0, sku.lastIndexOf("-"));
        } else if (productType == "Necklace" || productType == 'Pendant') {
            parts = sku.split("-");
            for (var i = parts.length - 1; i > 0; i--) {
                // check if part is numeric
                if (!isNaN(parseFloat(parts[i])) && isFinite(parts[i])) {
                    parts.pop();
                } else {
                    break;
                }
            }
            sku = parts.join("-");
        } else if (productType == "Bangle") {
            parts = sku.split("-");
            parts.pop();
            sku = parts.join("-");
        }
        return sku;
    },


    limitText: function (limitField, limitNum) {
        if (limitField.value.length > limitNum) {
            limitField.value = limitField.value.trim().substring(0, limitNum);
        }
    },


    addToWishList: function (params, callback) {

        /**
         *  epi                    int/string External product unique id (variant level if applicable)
         *    empi                int/string External product master id (if there is a group product id with different variant ids)
         *    iu                    string    Image-uri - Without protocol so protocol can be decided while rendering to http or https
         *    pr                    float    Price
         *    cprops [optional]    object data object that can be used to pass any custom data about the event
         *    hashtags [optional]    array array of wishlist collections to which this product needs to be added
         *
         *    For response        function A callback function, which takes a single argument (JSON response from the swym service)
         *    noShowNotification    boolean    Boolean for should the slide-out notification be shown. By default, this argument is false and the notification is shown
         */
        /* var params = {
            "epi": 123,
            "du": "https://yourstore.com/products/your-awesome-product",
            "empi": 1234,
            "iu": "//www.understandfrance.org/Images/AsterixObelix.jpg",
            "pr": 50,
            "variants": [{ "Blue / XL": 123 }]
        }; */

        window._swat.addToWishList(params,
            function (r) {
                callback(r);
            }
        );
    },


    customSelectBox: function () {
        Util.on(window.document, "change", ".custom-select:not(.disable-custom-dropdown) .uk-radio", function (e) {
            var ddb = e.target.parentNode.parentNode;
            var label_value = Util.data(e.target, "title");
            var ddb_label = Util.$(".label", ddb.parentNode);
            Util.html(ddb_label, label_value);
            UIkit.dropdown(ddb).hide();
        });
    },


    /**
     * Bold Options Select Box to Custom Selectbox
     */

    replaceBoldOptionsControls: function () {

        var selects = Util.$$(".bold_option_element select");

        var customDropdownTpl = "" +
            "<div><label class='uk-form-label'>{{FORM-LABEL}}</label>" +
            "<div class='custom-select custom-select-product'>" +
            "<button class='uk-button light push-icon-right' type='button' tabindex='-1' aria-expanded='false'>" +
            "<span data-select-option class='label'>{{LABEL}}</span>" +
            "<i class='icon-thin-down'></i>" +
            "</button>" +
            "<div data-uk-dropdown='offset:1;mode:click;animation:uk-animation-slide-bottom-small; duration: 200;delay-hide:50' class='uk-nav uk-dropdown-nav uk-dropdown'>" +
            "{{OPTIONS}}" +
            "</div>"
        "</div></div>";

        var optionTpl = "<label><input {{CHECKED}} name='{{NAME}}' type='radio' class='uk-radio uk-hidden uk-radio-alt' value=\"{{VALUE}}\" data-title=\"{{LABEL}}\"><span>{{LABEL}}</span></label>";

        Util.each(selects, function (item) {

            var optionWrapper = item.parentNode.parentNode.parentNode;
            var selectedValue = item.options[item.selectedIndex].value ? item.options[item.selectedIndex].value : 'Select option';

            Util.addClass(optionWrapper, "uk-hidden");

            // Extract Label
            var label = Util.$(".bold_option_title", optionWrapper).textContent;
            label = label.toUpperCase();

            var options = [];
            var ops = Util.$$("option", item);

            var i = 0, o = '';
            for (i; i < ops.length; i++) {
                o = optionTpl.replace(/{{LABEL}}/g, ops[i].value);
                o = o.replace(/{{VALUE}}/g, ops[i].value);
                o = o.replace(/{{NAME}}/g, item.className);

                if (ops[i].value == selectedValue) {
                    o = o.replace(/{{CHECKED}}/g, 'checked="checked"');
                } else {
                    o = o.replace(/{{CHECKED}}/g, ' ');
                }

                options.push(o);
            }

            options = options.join('');

            // Extract options
            var markup = customDropdownTpl.replace(/{{LABEL}}/g, selectedValue);
            markup = markup.replace(/{{OPTIONS}}/g, options);
            markup = markup.replace(/{{FORM-LABEL}}/, label);

            Util.after(optionWrapper, markup);

            // Bind Events for Radio buttons
            Util.on(document, "change", "input[name='" + item.className + "']", function (e) {

                var target = e.target;
                var boldSelect = Util.$("select." + item.className);

                // Set selected value
                theme.Utility.select(boldSelect, target.value);

                // Trigger change event
                boldSelect.dispatchEvent(new Event('change'));
            });
        });
    },


    /**
     *  Select option by value
     *
     * @param {*} selectElement
     * @param {*} optionValToSelect
     */
    select: function (selectElement, optionValToSelect) {

        //Get the select element by it's unique ID. Get the options.
        var selectOptions = selectElement.options;

        //Loop through these options using a for loop.
        for (var opt, j = 0; opt = selectOptions[j]; j++) {
            // If the option of value is equal to the option we want to select.
            if (opt.value == optionValToSelect) {
                // Select the option and break out of the for loop.
                selectElement.selectedIndex = j;
                break;
            }
        }
        // Enables chaining
        return selectElement;
    },


    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },


    /**
     * Renders product entry on the listing pages (collection, search etc.)
     *
     * @param {*} item
     * @param {*} show_sku
     */
    renderProduct: function (item, show_sku) {

        var formatedPrice,
            featured_image = item.featured_image ? item.featured_image : item.src,
            srcset = item.srcset ? 'data-srcset="' + item.srcset + '"' : '';

        var currentCurrency = theme.currencySign, sku = "";

        if (show_sku) {
            sku = (typeof item.selected_or_first_available_variant != "undefined") ? item.selected_or_first_available_variant.sku : item.variants[0].sku;
            sku = theme.Utility.formatSKU(item.type, sku);
            sku = '<small class="product-sku">' + sku + '</small>';
        }

        if (item.tags && item.tags.includes("POA")) {
            formatedPrice = currentCurrency + "POA";
        } else {
            if (item.price_varies || item.tags && item.tags.includes("price-varies")) {
                formatedPrice = (item.price_min.toString().indexOf(currentCurrency) > -1) ? item.price_min.toString() : theme.Currency.formatMoney(item.price_min, theme.moneyFormat);
                formatedPrice = '<span class="uk-text-muted uk-margin-xsmall-right">From</span>' + formatedPrice;
            } else {
                formatedPrice = (item.price.toString().indexOf(currentCurrency) > -1) ? item.price.toString() : theme.Currency.formatMoney(item.price, theme.moneyFormat);
            }
        }

        return [
            '<div class="uk-card uk-card-small uk-card-product ' + (item.available ? '' : 'sold-out') + '">',
            '<div class="uk-card-media-top">',
            '<img ' + srcset + ' data-src="' + featured_image + '" alt="' + item.alt + '" ',
            'data-uk-cover data-uk-img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">',
            '<div class="uk-overlay uk-position-bottom-right uk-text-right uk-visible@s">',
            '<small data-price class="uk-card-meta">' + formatedPrice + '</small>',
            '</div>',
            '<a href="' + item.url + '" class="read-more" aria-label="Details"></a>',
            '</div>',
            '<div class="uk-card-body">',
            '<div class="uk-flex uk-flex-between">',
            '<h2 class="uk-card-title">' + sku + '<a href="' + item.url + '">' + item.title + '</a></h2>',
            '<a href="#" data-btn-like="' + item.id + '" class="uk-icon-button large btn-like" aria-label="Like">',
            '<i class="icon-heartplus"></i>',
            '</a>',
            '</div>',
            '<div class="uk-flex uk-flex-between uk-flex-middle uk-margin-small-top">',
            '<a href="' + item.url + '" class="uk-button uk-button-text push-icon-right" aria-label="Details"></a>',
            '<small class="uk-card-meta"><strong>' + formatedPrice + '</strong></small>',
            '</div>',
            '</div>',
            '</div>'
        ].join("");
    },


    /**
     *
     * @param {*} arr
     * @param {*} v
     */
    removeEl: function (arr, v) {
        return arr.filter(function (el) {
            return el != v;
        });
    },


    /**
     * @param {*} obj
     */
    serialize: function (obj) {
        var arr = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                arr.push(key + '=' + obj[key]);
            }
        }
        return arr.join('&');
    },


    normalizeProductFormData: function (form, p) {


        console.log("normalizeProductFormData");

        var serialized = [],
            engravings = [],
            types = ["metal", "gem", "enamel"],
            engraving_text,
            checkbox, field, o;

        // Loop through each field in the form
        for (var i = 0; i < form.elements.length; i++) {

            field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            o = {};

            if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                if (field.name == 'id') {
                    var product_id = Util.data(field, "data-product-id"),
                        engraving_text = "",
                        checked, wr, key;

                    o = {
                        id: field.value, // This is selected Variant Id
                        properties: {}
                    };

                    var meta = p.metafields;

                    // Properties should have following order:
                    /**
                     * 1. Ringset       <---  Property
                     * 2. Metal           <---  Property
                     * 3. Gem           <---  Property
                     * 4. Enamel       <---  Property
                     * 5. Engraving       <---  Property
                     */

                    // Assign product properties
                    for (var t in types) {
                        if (wr = Util.$("[data-" + types[t] + "-related-products]")) {
                            checked = Util.$("input:checked", wr);
                            key = types[t].charAt(0).toUpperCase() + types[t].slice(1);
                            if (checked) {
                                o.properties[key] = encodeURIComponent(Util.data(checked, "title"));
                            } else {
                                o.properties[key] = encodeURIComponent(Util.$("[data-selected-option]", wr).innerHTML);
                            }
                        }
                    }

                    //@todo Add products Master collection into the properties

                    if (p.type == "Necklace" || p.type == "Bangle" || p.type == 'Bracelet' || p.type == 'Pendant') {
                        // Fetch meta fields
                        if (typeof meta['specs.chain_type'] !== "undefined") {
                            o.properties["_chain_type"] = meta['specs.chain_type'];
                        }
                        if (typeof p.metafields['specs.wire_type'] !== "undefined") {
                            o.properties["_wire_type"] = meta['specs.wire_type'];
                        }
                    }

                    if (typeof meta['spec.ring_width'] !== "undefined") {
                        o.properties["Ring Width"] = meta['spec.ring_width'];
                    }

                    /* Extract Engraving property if exists !!!!!!!!!TBD!!!!!!!!!!!!! */
                    /* if (Util.$("#engraving-text" + product_id + " [data-engraving-text]")) {
                         engraving_text = Util.$("#engraving-text" + product_id + " [data-engraving-text]").value,
                             checkbox = Util.$("#engraving_cb" + product_id);

                         // Find out if this ring has engraving
                         if (checkbox.checked && engraving_text != "") {
                             o.properties["Engraving"] = encodeURIComponent(engraving_text);
                         }
                     }*/

                    /* Get/Set product's main collection */
                    var collection = p.tags.filter(function (item) {
                        return item.indexOf("Collection-") !== -1
                    });
                    if (collection.length > 0) {
                        collection = collection[0].replace("Collection-", "");
                        o.properties["_collection"] = encodeURIComponent(collection);
                    }


                    // Add BOLD Option Custom props

                    var $bold_options_container = Util.$(".bold_options");
                    if ($bold_options_container) {

                        var bold_ffs = Util.$$("[name^=properties]", $bold_options_container), i;

                        for (ii = 0; ii < bold_ffs.length; ii++) {

                            var item = bold_ffs[ii];

                            if (item.type != "checkbox" && item.type != "radio") {

                                // Small hack. Rename Engraving Text property to "Engraving" plus ignore hidden fields
                                // with value "✓", except for Gift Wrap

                                // Extract field name:
                                if (item.value == '✓' && item.name == 'Engraving') {
                                    continue;
                                }

                                var f_name = item.name.substring(item.name.lastIndexOf("[") + 1, item.name.lastIndexOf("]"));

                                if (f_name == 'Engraving Text') {
                                    f_name = 'Engraving';
                                }

                                // We should skip it and take in cosiduration hidden field related to the skipped item.
                                o.properties[f_name] = item.value;
                            }
                        }
                    }

                    serialized.push(o);
                }
            }
        }


        // Add Engraving product to the list of products that will be added to the Cart.
        /*if (!_.isEmpty(engravings)) {
            serialized.push({
                id: engravings[0].id,
                properties: engravings[0].properties
            });
        }*/

        return serialized;
    },


    serializeForm: function (form) {

        // Setup our serialized data
        var serialized = [];

        // Loop through each field in the form
        for (var i = 0; i < form.elements.length; i++) {

            var field = form.elements[i];
            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push({
                        name: field.name,
                        value: field.options[n].value
                    });
                }
            } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push({name: field.name, value: field.value});
                //serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
        }
        return serialized;
        //return serialized.join("&");
    },


    dialog: function (message, type) {

        var modal = [
            '<div class="uk-position-top uk-width-1-1 uk-z-index-10">',
            '<div class="uk-alert ' + type + '" data-uk-alert>',
            '<div class="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle">',
            '<div>',
            '<p>' + message + '&nbsp;&nbsp;&nbsp;&nbsp;</p>',
            '</div>',
            '<div>',
            '<a href="#" data-uk-close class="uk-modal-close" arial-label="Close Popup"></a>',
            '</div>',
            '</div>',
            '</div>',
            '</div>'
        ].join("");

        UIkit.modal.dialog(modal);
    },


    message: function (message, type) {
        UIkit.modal.dialog('<p class="uk-modal-body">' + message + '</p>');
    },

    /**
     * Get the query params in a Url
     * Ex
     * https://mysite.com/search/?q=noodles&b
     * getParameterByName('q') = "noodles"
     * getParameterByName('b') = "" (empty value)
     * getParameterByName('test') = null (absent)
     */
    getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
    }
};


theme.policiesPages = {
    init: function () {
        var $container = Util.$(".shopify-policy__container");
        if ($container) {
            var p = Util.$(".shopify-policy__body", $container);
            var iubembed = Util.$(".iub-body-embed");
            if ((typeof $container != "undefined" && $container != null) || iubembed != null) {
                if ($container) {
                    Util.addClass(p, "content");
                    Util.addClass($container, "uk-container uk-container-small");
                }
                // iubenda
                (function (w, d) {
                        var loader = function () {
                            var s = d.createElement("script"),
                                tag = d.getElementsByTagName("script")[0];
                            s.src = "https://cdn.iubenda.com/iubenda.js";
                            tag.parentNode.insertBefore(s, tag);
                        };
                        if (w.addEventListener) {
                            w.addEventListener("load", loader, false);
                        } else if (w.attachEvent) {
                            w.attachEvent("onload", loader);
                        } else {
                            w.onload = loader;
                        }
                    }
                )(window, document);
            }
        }
    }
}


theme.shopPages = {

    init: function () {


        // Get PlaceId if exists
        if (Util.$("#ShopPlaceIdJson") == null) {
            return false;
        }

        var jsonStr = document.getElementById('ShopPlaceIdJson').innerHTML,
            place = JSON.parse(jsonStr);

        if (!place.place_id) {
            return false;
        }

        var map = new google.maps.Map(document.getElementById("map-canvas"));

        console.log(place.place_id)

        var request = {
            //placeId: "ChIJZffMN2EBm0gRcQZC76NH0Kw",
            placeId: place.place_id,
            fields: ["opening_hours.weekday_text"]
        };

        var service = new google.maps.places.PlacesService(map);
        service.getDetails(request, theme.shopPages.render);
    },

    /**
     *
     */
    render: function (place, status) {

        var content = [];

        if (status == google.maps.places.PlacesServiceStatus.OK && place.opening_hours) {

            // Render table
            var days = place.opening_hours.weekday_text, r, d, days, parts;
            content.push('<table class="uk-table opening-hours">');

            for (var i = 0; i < days.length; i++) {
                parts = days[i].split(" ");
                d = parts[0].trim();
                r = days[i].replace(d, '').trim();
                content.push('<tr><td><strong>' + d + '</strong></td><td>' + r + '</td></tr>');
            }
            content.push('</table>');
        } else {

        }

        // Inject content
        var ph = document.getElementById('OpeningHoursPlaceholder');

        if (ph) {
            var newEl = document.createElement('div');
            newEl.classList.add("uk-overflow-auto");
            newEl.innerHTML = content.join("");
            ph.parentNode.replaceChild(newEl, ph);
        }
    }
}

window.getOpeningHours = theme.shopPages.init;

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {

    wrapImage: function (images) {
        Util.each(images, function (item) {
            var alt = Util.attr(item, "alt"),
                classes = Util.attr(item, "class") ? Util.attr(item, "class") : "";
            Util.removeClass(item, classes);
            var f = Util.wrapAll(item, '<figure class="' + classes + '">');
            if (alt) {
                Util.append(f, "<figcaption>" + alt + "</figcaption>");
            }
        });
    },

    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function (options) {
        Util.each(options.$tables, function (item) {
            Util.wrapAll(item, '<div class="' + options.tableWrapperClass + '">');
        });
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function (options) {

        Util.each(options.$iframes, function (item) {

            // Add wrapper to make video responsive
            Util.wrapAll(item, '<div class="' + options.iframeWrapperClass + '">');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            item.src = item.src;
        });
    }
};

var sections = sections || new theme.Sections();

Util.ready(function () {
    $site.init();

    theme.init();

    if (theme.customerTemplates) {
        theme.customerTemplates.init();
    }

    theme.policiesPages.init();

    // Section Register
    sections.register('search', theme.Search);

    sections.register('product', theme.ProductIncommon);
    sections.register('product', theme.Product);

    sections.register('product-ringset', theme.RingSet);
    sections.register('product-ringset', theme.ProductIncommon);

    sections.register('collection', theme.Collection);
    sections.register('cart-template', theme.Cart);

    sections.register('product-recommendations', theme.ProductRecommendations);
    // If we make 2 or more ajax requests
    setTimeout(function () {
        sections.register('product-recent', theme.ProductRecent);
    }, 500);
    sections.register('product-wear-it-with', theme.WearItWith);

    // CartPopup
    window.popupCart = new theme.PopupCart("#cart-small-popup");

    // Currency selector
    var cs = new theme.CurrencySelector(".currency-selector");

    // We have to make sure that third party JS finished it's magic. Unfortunately it has not any hook/trigger event or similar
    setTimeout(function () {
        var newsletterForm = new theme.NewsletterForm(".cmApp_embedFormContainer");
    }, 5000);
});


// Polyfills
// ===================================

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';

        if (search instanceof RegExp) {
            throw TypeError('first argument must not be a RegExp');
        }
        if (start === undefined) {
            start = 0;
        }
        return this.indexOf(search, start) !== -1;
    };
}